module.exports = __webpack_public_path__ + "static/media/sample2.9ea60f6f.png";